import { render, staticRenderFns } from "./ChatSidebar.vue?vue&type=template&id=068dd861&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChatSidebar.vue?vue&type=style&index=0&id=068dd861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068dd861",
  null
  
)

export default component.exports